<script>
  // components
  import PreferenceMenu from "./menu/preferenceSetting.svelte";
  import ExportMenu from "./menu/exportSetting.svelte";
  import Previewer from "./component/previewer.svelte";
  import ExplorationHistoryMenu from "./menu/explorationHistorySetting.svelte";
  import { devicePreview, currMenu, systemLog } from "../editor/storage.js";
  import { onMount } from "svelte";
  
  // variables
  export let preventKeyboardAction;

  // event functions
  export let inputFocusAction;
  export let inputBlurAction;

  //preview-related
  if ($currMenu === "preview") {
    devicePreview.set(true);
  } else {
    devicePreview.set(false);
  }
  onMount(() => {
    $systemLog.log({ message: "Opened a menu", menu: $currMenu });
  });
</script>

{#if $currMenu === "preference"}
  <PreferenceMenu
    {preventKeyboardAction}
    {inputFocusAction}
    {inputBlurAction}
  />
{:else if $currMenu === "export"}
  <ExportMenu {preventKeyboardAction} {inputFocusAction} {inputBlurAction} />
{:else if $currMenu === "preview"}
  <Previewer />
{:else if $currMenu === "exploration_history"}
  <ExplorationHistoryMenu />
{:else}
  <h2>{$currMenu}</h2>
{/if}
